<div class="outline-chat">
  <div class="outline-chat-header">
    <span class="outline-chat-title">{{ 'guidedCourseCreation.chat.title' | translate }}</span>
    <app-tooltip-button [tooltipKey]="'tooltips.guidedCourseCreation.chat'"></app-tooltip-button>
  </div>

  <div class="outline-chat-messages" #messagesContainer>
    <div class="outline-chat-messages-spacer"></div>
    @for (message of messages(); track $index) {
      @switch (message.type) {
        @case (MESSAGE_TYPES.USER) {
          <div class="message-row message-row--user">
            <div class="message-bubble message-bubble--user">
              {{ message.content }}
            </div>
          </div>
        }
        @case (MESSAGE_TYPES.AI) {
          <div class="message-row message-row--ai">
            <div class="message-bubble message-bubble--ai">
              {{ message.content }}
            </div>
          </div>
        }
      }
    }

    @if (isFetching()) {
      <div class="message-row message-row--ai">
        <app-hourglass-spinner></app-hourglass-spinner>
      </div>
    }

    @if (pendingPreview(); as preview) {
      <div class="message-preview">
        <div class="message-preview-content">
          <span class="message-preview-title">{{ 'guidedCourseCreation.chat.preview' | translate }}</span>
          <p class="message-preview-description">{{ preview.content }}</p>
          @if (preview.affectedItems?.length) {
            <div class="message-preview-affects">
              <span class="message-preview-affects-title">{{ 'guidedCourseCreation.chat.willAffect' | translate }}</span>
              <ul class="message-preview-affects-list">
                @for (item of preview.affectedItems; track $index) {
                  <li>{{ item }}</li>
                }
              </ul>
            </div>
          }
        </div>
        <div class="message-preview-buttons">
          <button
            class="message-preview-cancel"
            (click)="cancelPreview()"
          >
            <mat-icon>close</mat-icon>
            <span class="message-preview-btn-text">{{ 'common.cancel' | translate }}</span>
          </button>
          <button
            class="message-preview-approve"
            (click)="approvePreview()"
          >
            <mat-icon>check</mat-icon>
            <span class="message-preview-btn-text">{{ 'guidedCourseCreation.chat.approve' | translate }}</span>
          </button>
        </div>
      </div>
    }
  </div>

  <div class="outline-chat-input">
    <textarea
      [formControl]="messageForm.controls.content"
      [placeholder]="'guidedCourseCreation.chat.placeholder' | translate"
      (keydown)="onKeydown($event)"
    ></textarea>
    <button
      class="outline-chat-send"
      [class.outline-chat-send--disabled]="isInputDisabled()"
      [disabled]="isInputDisabled()"
      (click)="sendMessage()"
    >
      <mat-icon>arrow_upward</mat-icon>
    </button>
  </div>
</div>
